const HeroBanner = props => {
  const { bannerBody, bannerTitle, bannerEyebrow, bannerButtons } = props

  return (
    <div className='home-hero-banner'>
      <div className='hero-banner-inner'>
        {bannerEyebrow && <h4 className='link'>{bannerEyebrow}</h4>}
        <h2 className='heading2 intro__heading'>{bannerTitle}</h2>
      </div>
      <p>{bannerBody}</p>
      <div className='home-hero-buttons'>
        {bannerButtons.map(btn => (
          <a
            className='link'
            href={btn.button_link_copy.url}
            target={btn.button_link_copy.target}
            rel='noopener noreferrer'
          >
            {btn.button_link_copy.title}
          </a>
        ))}
      </div>
    </div>
  )
}

export default HeroBanner
